import jwt_decode from "jwt-decode";
import { ToastType } from "../components/Toasts/ToastType";
import { getUserToken } from "../components/UserUtils";
import { storeToast } from "../components/Utils";
import {userLogout} from "../features/Slice/UserSlice";
import { store } from "./store";

export const tokenExpiredCheckMiddleware = ({dispatch, getState}: any) =>{
  return (next: any) => (action: any) => {
    if(action.type && action.type.toLowerCase().includes("logout"))
    {
      return next(action);
    }
    else
    {
      const token = getUserToken();

      if(token)
      {
        try
        {
          const decodedToken: {exp: number} = jwt_decode(token);
          const nowTimestamp = Math.floor(new Date().getTime() / 1000);

          if(nowTimestamp >= decodedToken.exp) //Token expired, we logout
          {
            storeToast(ToastType.ERROR, "expired_session");
            store.dispatch(userLogout(true));
          }
        }
        catch(err)
        {
        }
      }
    }

    return next(action);
  }
}
